// src/Terms.js
import React from 'react';
import { Link } from 'react-router-dom';

function Terms() {
  return (
    <div className="left-align">
      <h1>Terms & Conditions</h1>
      <p>These terms apply to the Fampack app and website. Fampack is run by Allan Dong Fang Zhang.</p>
      <p>
        By using Fampack, you agree to these terms. Do not copy, modify,
        reverse-engineer or misuse the app, website, trademarks or other
        intellectual property. You are responsible for keeping your device and
        account secure, and for any data or carrier charges that apply to your
        use of the service.
      </p>
      <p>
        Fampack may change, suspend or stop parts of the service, and may update
        the app. We will post updated terms on this page when they change.
      </p>

      <h2>Zero Tolerance for Objectionable Content and Abusive Users</h2>
      <p>
        Fampack has zero tolerance for objectionable content and abusive users.
        You must not post, comment or share anything that is abusive, harassing,
        hateful, sexually explicit, spam, fraudulent, or that puts children at
        risk, and you must not use Fampack to abuse, harass or threaten anyone.
      </p>
      <p>
        Fampack automatically masks listed words in new post titles, captions and
        comments. The list is maintained by the team and can change over time.
        Usernames that contain listed terms may be refused.
      </p>
      <p>
        Anyone can report a post, comment or account in the app by opening the
        menu, choosing Report and selecting a reason. Anyone can also block
        another account. A block ends follows, friendships and friend requests
        between the two accounts and hides each account from the other.
      </p>
      <p>
        Moderators review reports and may remove content, suspend accounts or ban
        accounts that break these terms. Removed content is hidden from the app.
        If you think a decision about your content or your account is wrong,
        contact us at <a href="mailto:team@fampack.net">team@fampack.net</a>.
      </p>

      <h2>Account deletion</h2>
      <p>
        You can delete your account in the iPhone app from Settings → Account →
        Delete account. Suspended or banned accounts can also start deletion from
        the locked screen. Deletion requires a fresh sign-in code.
      </p>
      <p>
        When deletion is scheduled, the account is hidden immediately, every
        device is signed out, and the account is deleted 30 days later. Signing
        in to the iPhone app before then cancels the deletion. The website cannot
        delete or cancel account deletion.
      </p>
      <p>
        The purge deletes the account and its content. Fampack keeps only what it
        needs for safety: reports the account filed, with the reporter removed;
        content a moderator removed, until an admin deletes it for good; and, for
        a banned account, a keyed hash of its phone number and email address to
        stop ban evasion. The{' '}
        <Link to="/privacy">Privacy Policy</Link> explains this in more detail.
      </p>

      <h2>Contact</h2>
      <p>
        If you have questions or suggestions about these terms, contact Fampack
        at <a href="mailto:team@fampack.net">team@fampack.net</a> or visit{' '}
        <Link to="/support">Support</Link>.
      </p>
      <p>These terms are effective as of 4 October 2026.</p>
    </div>
  );
}

export default Terms;
